import React from 'react';

export default function ReportRemark({ remarks }) {
  if (remarks?.length === 0) {
    return null;
  }
  return(
    <div className="report-section">
      <h2>Inspector's Remark</h2>
      <div className="verdict">
        <h3>Transparency Above Everything</h3>
        {remarks.map((remark, index) => (
          <p key={index}>
            {remark}
          </p>
        ))}
        <hr />
        <strong>
          We don't tell you whether a car had an accident.
          We tell you what happened, where it happened,
          and why it matters.
        </strong>
      </div>
    </div>
  )
}

